import React, { useEffect, useState } from "react";
import { useParams, useNavigate, useLocation } from "react-router-dom";
import SpareDetailsById from "../../services/SpareDetailsById";
import { useLoading } from "../../common/LoadingContext";
import { useNotificationContext } from "../../common/NotificationContext";
import { Container, Grid, Paper, Typography, IconButton } from "@mui/material";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";

const SpareDetails = (props) => {
  const { onClearClick } = props;
  const { setLoading } = useLoading();
  const { showNotification } = useNotificationContext();
  const [detailData, setDetailData] = useState("");
  const [isFromNotification, setIsFromNotification] = useState(false);
  const id = useParams();
  const navigate = useNavigate();
  const { state } = useLocation();
  const history = useLocation();
  console.log("state in spare details", state);

  useEffect(() => {
    if (history.pathname.includes('spare-details-view')) {
      if (state) {
        detailById(id);
      }
    }
    else {
      detailById(parseInt(state?.spareId));
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [state]);

  const detailById = async (id) => {
    try {
      setLoading(true);
      const param = {
        spareId: state?.fromNotification ? id.spareId : parseInt(state?.spareId),
      };
      const detailResp = await SpareDetailsById(param);
      if (detailResp.statusCode === 6) {
        setDetailData(detailResp.data);
      } else {
        showNotification(
          "Error",
          detailResp?.message ?? "Failed to fetch spare data"
        );
      }
    } catch (err) {
      showNotification("Error", "Failed to fetch spare data" + err);
    } finally {
      setLoading(false);
    }
  };

  const goBack = () => {
    if (state.fromModel) {
      navigate("/model-search/model-view", {
        state: {
          modelId: state.model_id, brandName: state?.brand_name,
          modelCode: state?.model_code,
        }
      });
    }
    else {
      // onClearClick()
      navigate("/spare-search");
    }
    // navigate("/spare-search");
  };

  return (
    <>
      <Container maxWidth="lg" sx={{ mt: 5 }}>
        <Grid item xs={6} sx={{ px: 0, mb: 0, ml: 0 }}>
          <Typography
            align="left"
            sx={{ ml: 0, mt: 3, color: "#567aac" }}
            variant="h6"
          >
            {
              state?.fromNotification ?
                <IconButton sx={{ color: "#567aac" }}>
                  <ArrowBackIcon
                    onClick={() =>
                      navigate(`/notifications`, {
                        state: {
                          // content: response,
                          isUnRead: true,
                          // sorting: true,
                          pageNo: state?.pageNo,
                          typeId: state?.typeId,
                          isFromRead: state?.isFromRead
                        },
                      })

                    }
                  />
                </IconButton>
                :
                <IconButton sx={{ color: "#567aac" }}>
                  <ArrowBackIcon onClick={goBack} />
                </IconButton>
            }

            Spare Details: {detailData?.name ?? "-"}
          </Typography>
        </Grid>
        <Paper
          elevation={3}
          sx={{ width: "100%", overflow: "hidden", margin: "auto" }}
        >
          <Grid >
            <Grid item xs={12} sx={{ textAlign: "left" }}>
              <table className="table detailTable  table-striped" size="small" >
                <thead>
                  <tr>
                    <th>Fields</th>
                    <th>Values</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td className="boldHeading">Spare Short Name</td>
                    <td>{detailData?.shortName ?? "-"}</td>
                  </tr>
                  <tr>
                    <td>Spare specifications</td>
                    <td>{detailData?.description ?? "-"}</td>
                  </tr>
                  <tr>
                    <td>Spare dimensions</td>
                    <td>{detailData?.dimension ?? "-"}</td>
                  </tr>
                  <tr>
                    <td>RetailPR</td>
                    <td>{detailData?.retailPR ?? "-"}</td>
                  </tr>
                  <tr>
                    <td>Spare packaging information while dispatch</td>
                    <td>{detailData?.packInfo ?? "-"}</td>

                  </tr>
                  <tr>
                    <td>Spare application and installation</td>
                    <td>{detailData?.appInstall ?? "-"}</td>
                  </tr>
                  <tr>
                    <td>Special care to be taken</td>
                    <td>{detailData?.spCare ?? "-"}</td>
                  </tr>
                  <tr>
                    <td>Defective spare action</td>
                    <td>{detailData?.defSpareActionName ?? "-"}</td>
                  </tr>
                  <tr>
                    <td>Alternate article</td>
                    <td>{detailData?.hasAlternateSpare ?? "-"}</td>
                  </tr>
                  <tr>
                    <td>Spec</td>
                    <td>{detailData?.spec ?? "-"}</td>
                  </tr>
                  <tr>
                    <td>Status Name</td>
                    <td>{detailData?.statusName ?? "-"} </td>
                  </tr>
                  <tr>
                    <td>Spare warranty</td>
                    <td>{detailData?.warranty ?? "-"} </td>
                  </tr>
                  <tr>
                    <td>Part Type Name</td>
                    <td>{detailData?.partTypeName ?? "-"} </td>
                  </tr>
                  <tr>
                    <td>Vendors:</td>
                    <td>
                      <ul>
                        {detailData?.vendorRespList?.map((row, index) => {
                          return detailData?.vendorRespList.length > 1 ? (
                            <li key={index}>{row.name + " - " + row.code}</li>
                          ) : (
                            row.name + " - " + row.code
                          );
                        })}{" "}
                      </ul>
                    </td>
                  </tr>
                  <tr>
                    <td>Suppliers:</td>
                    <td>
                      <ul>
                        {detailData?.supplierList?.map((row, index) => {
                          return detailData?.supplierList.length > 1 ? (
                            <li key={index}>{row.name + " - " + row.code}</li>
                          ) : (
                            row.name + " - " + row.code
                          );
                        })}{" "}
                      </ul>
                    </td>
                  </tr>

                  <tr>
                    <td>Spare Status</td>
                    <td>{detailData?.spareStatusDsc ?? "-"}</td>
                  </tr>
                  <tr>
                    <td>Spare Description</td>
                    <td>{detailData?.description ?? "-"}</td>
                  </tr>
                  <tr>
                    <td>Supplier Article Code</td>
                    <td>{detailData?.spareAcode ?? "-"}</td>
                  </tr>
                  <tr>
                    <td>Modified By</td>
                    <td>{detailData?.modifiedByName ?? "-"}</td>
                  </tr>
                  <tr>
                    <td>Modified On</td>
                    <td>{detailData?.modifiedOn?.slice(0,10) ?? "-"}</td>
                  </tr>
                  <tr>
                    <td>Created By</td>
                    <td>{detailData?.createdByName ?? "-"}</td>
                  </tr>
                  <tr>
                    <td>Created On</td>
                    <td>{detailData?.createdOn?.slice(0,10) ?? "-"}</td>
                  </tr>
                </tbody>
              </table>
            </Grid>
          </Grid>
        </Paper>
      </Container>
    </>
  );
};

export default SpareDetails;
